<div *ngIf="spin" class="d-flex justify-content-center">
  <app-spinner></app-spinner>
</div>
<nb-card *ngIf="!spin" accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex flex-column">
        <div>{{ getTitle() }}</div>
        <div>{{ getSubtitle() }}</div>
        <div *ngIf="environment !== 'dev' && diff && !noDrb" class="mt-2">
          {{ getLatestSuccessfulVersionLabel() }} {{ diff.last_successful_version }}
        </div>
        <div *ngIf="environment !== 'dev' && diff && !noDrb">
          {{ getDraftOrCandidateVersionLabel() }} {{ getDraftOrCandidateVersion() }}
        </div>
        <div *ngIf="environment !== 'dev' && diff && !noDrb" [ngClass]="getStatusClass()" i18n>
          Deployment Status: {{ getDraftOrCandidateStatus() }}
        </div>
        <div *ngIf="deploying" class="d-flex align-items-center">
          <nb-icon class="m-2" icon="info-outline"></nb-icon>
          <i i18n>Please click Refresh button to update the deployment status.</i>
        </div>
        <div *ngIf="isDeployFailed()" class="d-flex align-items-center">
          <nb-icon class="m-2" icon="info-outline"></nb-icon>
          <strong style="color: red" i18n>
            DRB version {{ getDraftOrCandidateVersion() }} failed to deploy. For more information contact Insights team.
          </strong>
        </div>
      </div>
      <div>
        <button
          nbButton
          class="ml-3"
          outline
          status="info"
          shape="round"
          size="small"
          (click)="refresh()"
          nbTooltip="Refresh"
          i18n-nbTooltip
        >
          <nb-icon icon="refresh-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row" *ngIf="noDrb">
      <div class="col-auto mr-auto" i18n>There is no DRB draft version for comparison.</div>
    </div>
    <div *ngIf="!diff.diff && !noDrb">
      <div class="col-auto mr-auto">
        {{ getNoDiffMessage() }}
      </div>
    </div>
    <div *ngIf="diff.diff && !noDrb">
      <div>
        <strong class="text-uppercase" i18n>Strings</strong>
        <hr />
        <div *ngIf="diffXliff.added.length > 0">
          <p><b i18n>Added</b></p>
          <div *ngFor="let item of diffXliff.added">
            <app-xliff-added [item]="item"> </app-xliff-added>
            <br />
          </div>
        </div>
        <div *ngIf="diffXliff.updated.length > 0">
          <p><b i18n>Updated</b></p>
          <div *ngFor="let item of diffXliff.updated">
            <app-changed [item]="item"></app-changed>
            <br />
          </div>
        </div>
        <div *ngIf="diffXliff.removed.length > 0">
          <p><b i18n>Removed</b></p>
          <div *ngFor="let item of diffXliff.removed">
            <app-xliff-removed [item]="item"></app-xliff-removed>
            <br />
          </div>
        </div>
      </div>
      <br />

      <div *ngFor="let source of diffSources">
        <strong class="text-uppercase">{{ source.sourceName }}</strong>
        <hr />
        <div *ngIf="source.diffItems.added.length > 0">
          <p><b i18n>Added</b></p>
          <div *ngFor="let item of source.diffItems.added">
            <app-source-added [item]="item"></app-source-added>
            <br />
          </div>
        </div>
        <div *ngIf="source.diffItems.updated.length > 0">
          <p><b i18n>Updated</b></p>
          <div *ngFor="let item of source.diffItems.updated">
            <app-changed [item]="item"></app-changed>
            <br />
          </div>
        </div>
        <div *ngIf="source.diffItems.removed.length > 0">
          <p><b i18n>Removed</b></p>
          <div *ngFor="let item of source.diffItems.removed">
            <app-source-removed [item]="item"></app-source-removed>
            <br />
          </div>
        </div>
        <br />
      </div>
      <hr />
      <div class="row">
        <div class="col-auto mr-auto">
          <div *ngIf="!translating && allowDeploy">
            <button
              nbButton
              status="success"
              size="small"
              shape="round"
              [disabled]="disableButton"
              (click)="deployNewDrb()"
              i18n
            >
              Deploy
            </button>
          </div>
          <div *ngIf="translating">
            <b i18n>Deployment is disabled while DRB is in translation process.</b>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <i i18n>All times displayed are in local timezone.</i>
  </nb-card-footer>
</nb-card>
